import { useNavigate } from 'react-router';
import { useTranslation } from '../i18n/I18nProvider';
import { trialBadgeKey } from '../lib/trial';
import { Badge, Button, Card } from '../ui';
import { IconLock } from './icons';

export interface LockedWorkoutProps {
  /** Ime treninga kad ga znamo — ekran zaključanog treninga nije anoniman zid. */
  name?: string | null;
  /** Koliko je treninga besplatno; dolazi iz `lock.trialCount` ili `trial.total`. */
  trialCount?: number | null;
  className?: string;
}

/**
 * Zaključan trening. Isti ekran pokriva DVA puta do njega:
 *  - `/v1/training/today` s `reason: 'locked'`
 *  - `/v1/training/workouts/:id` s 402
 * Nijedan od njih ne smije završiti kao prazno stanje ili generička greška.
 */
export function LockedWorkout({ name, trialCount, className }: LockedWorkoutProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Card data-testid="locked-workout" className={className}>
      <div className="flex flex-col items-center gap-4 py-6 text-center">
        <span aria-hidden="true" className="text-accent">
          <IconLock width={40} height={40} />
        </span>
        <h2 className="font-display text-[24px] font-semibold leading-tight text-ink">
          {t('trial.lockedTitle')}
        </h2>
        {name && <p className="text-[14px] text-ink-muted">{t('trial.lockedFrom', { name })}</p>}
        {typeof trialCount === 'number' && trialCount > 0 && (
          <Badge tone="accent">{t(trialBadgeKey(trialCount), { n: trialCount })}</Badge>
        )}
        <p className="max-w-prose text-[14.5px] leading-relaxed text-ink-muted">
          {t('trial.lockedHelp')}
        </p>
        <Button className="mt-1" onClick={() => void navigate('/pretplata')}>
          {t('trial.unlock')}
        </Button>
      </div>
    </Card>
  );
}
